<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>平台钱包</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">平台钱包</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="关联人类型">
                  <el-select
                    v-model="ruleForm.type"
                    placeholder="请选择关联人类型"
                    style="margin-right: auto"
                  >
                    <el-option label="客户" value="1"></el-option>
                    <el-option label="保安" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    :value="ruleForm.name"
                    @input="isUserType"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    :value="ruleForm.phone"
                    @input="isUserType1"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="动账类型">
                  <el-select
                    v-model="ruleForm.type1"
                    placeholder="请选择动账类型"
                    style="margin-right: auto"
                  >
                    <el-option label="收入" value="0"></el-option>
                    <el-option label="支出" value="1"></el-option>
                    <el-option label="挂账" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="业务类型">
                  <el-select
                    v-model="ruleForm.type2"
                    placeholder="请选择业务类型"
                    style="margin-right: auto"
                  >
                    <el-option
                      :label="item.propDesc"
                      :value="item.propValue"
                      v-for="(item, index) in typeList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="任务编号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.jobNo"
                    placeholder="请输入任务编号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="时间">
                  <div style="display: flex; align-items: center">
                    <el-date-picker
                      v-model="ruleForm.time"
                      type="datetime"
                      placeholder="选择开始时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                    <div style="margin: 0 5px">-</div>
                    <el-date-picker
                      v-model="ruleForm.time1"
                      type="datetime"
                      placeholder="选择结束时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item style="margin-top: 10px">
                  <el-button type="primary" @click="search()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button type="primary" @click="exportList()" class="btn"
          >excel导出</el-button
        >
        <div
          style="
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            font-size: 24px;
          "
        >
          <div>收入金额：￥{{ pageInfo.incomeAmount }}</div>
          <div style="margin: 0 50px">
            支出金额：￥{{ pageInfo.outcomeAmount }}
          </div>
          <div>余额：￥{{ pageInfo.balanceAmount }}</div>
        </div>
        <TableScrollSlider :table-ref="$refs.multipleTable" />
        <el-table
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column
            prop="billDetailNo"
            label="帐单编号"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="jobNo"
            label="任务编号"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="类型" align="center">
            <template slot-scope="scope">
              {{
                scope.row.changeTo == 0
                  ? "收入"
                  : scope.row.changeTo == 1
                  ? "支出"
                  : "挂账"
              }}</template
            >
          </el-table-column>
          <el-table-column label="业务类型" align="center">
            <template slot-scope="scope"> {{ scope.row.changeName }}</template>
          </el-table-column>
          <el-table-column label="金额" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.actualAmount }}</template
            >
          </el-table-column>
          <el-table-column label="关联交易号" align="center" width="120">
            <template slot-scope="scope"> {{ scope.row.businessNo }}</template>
          </el-table-column>
          <el-table-column label="关联人" align="center" width="150">
            <template slot-scope="scope"> {{ scope.row.targetName }}</template>
          </el-table-column>
          <el-table-column label="关联人类型" align="center">
            <template slot-scope="scope">
              {{ scope.row.targetTypeName }}</template
            >
          </el-table-column>
          <el-table-column prop="userName" label="操作人" align="center">
          </el-table-column>
          <el-table-column
            prop="userOperateTime"
            label="操作时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.status == 0">对账中</span>
              <span class="greenColor" v-if="scope.row.status == 1"
                >已到账</span
              >
              <span class="redColor" v-if="scope.row.status == 2">已退款</span>
              <el-popover
                trigger="hover"
                placement="top"
                v-if="scope.row.status == 3"
              >
                <p>失败(提现失败)</p>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="disAround" v-if="scope.row.status != 3">
                <div class="operateBtn" @click="Invoicing(scope.row)"></div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.financeData(),
      ruleForm: {
        time: "",
        time1: "",
        name: "",
        phone: "",
        type: "",
        type1: "",
        type2: "",
        jobNo: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      multipleTable: [],
      typeList: [],
      pageInfo: {},
    };
  },
  mounted() {
    this.getType();
    this.getList();
  },
  methods: {
    isUserType(val) {
      if (this.ruleForm.type == "") {
        this.$message({
          message: "请选择关联人类型",
          type: "warning",
        });
        return;
      } else {
        this.ruleForm.name = val;
      }
    },
    isUserType1(val) {
      if (this.ruleForm.type == "") {
        this.$message({
          message: "请选择关联人类型",
          type: "warning",
        });
        return;
      } else {
        this.ruleForm.phone = val;
      }
    },
    exportList() {
      this.$confirm("是否导出数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let arr = [];
          if (this.multipleTable.length != 0) {
            for (var i = 0; i < this.multipleTable.length; i++) {
              arr.push(this.multipleTable[i].id);
            }
          }
          let param = {
            ids: arr,
          };
          if (this.ruleForm.type1 != "") {
            param.changeTo = this.ruleForm.type1;
          }
          if (this.ruleForm.type2 != "") {
            param.changeType = this.ruleForm.type2;
          }
          if (this.ruleForm.time != "") {
            param.startTime = this.ruleForm.time;
          }
          if (this.ruleForm.time1 != "") {
            param.endTime = this.ruleForm.time1;
          }
          if (this.ruleForm.name != "") {
            param.targetName = this.ruleForm.name;
          }
          if (this.ruleForm.phone != "") {
            param.targetPhone = this.ruleForm.phone;
          }
          if (this.ruleForm.jobNo != "") {
            param.jobNo = this.ruleForm.jobNo;
          }
          if (this.ruleForm.type != "") {
            param.targetType = this.ruleForm.type;
          }
          this.$axios
            .post("/admapi/platformwallet/listexport", param, {
              responseType: "blob",
            })
            .then((data) => {
              console.log(data);
              let val = new Blob([data.data], {
                type: "application/vnd.ms-excel;charset=utf-8",
              });
              let header = decodeURI(data.headers["content-disposition"]);
              console.log(header);
              let index = header.indexOf("''");
              let fileName = header.substring(index + 2, header.length);
              const url = window.URL.createObjectURL(val);
              const link = document.createElement("a");
              link.download = fileName; // 设置a标签的下载属性
              link.style.display = "none";
              link.href = url;
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
              document.body.removeChild(link);
            })
            .catch()
            .finally();
          // );
        })
        .catch(() => {});
    },
    search() {
      this.page = 1;
      this.getList();
    },
    getType() {
      let param = {
        key: "billDetailChangeTypeByPlatform",
        orderColumn: "sort",
        isAsc: "1",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.typeList = data;
        })
        .catch()
        .finally();
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.phone = "";
      this.ruleForm.type = "";
      this.ruleForm.type1 = "";
      this.ruleForm.jobNo = "";
      this.ruleForm.type2 = "";
      this.ruleForm.time = "";
      this.ruleForm.time1 = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        changeTo: this.ruleForm.type1,
        changeType: this.ruleForm.type2,
        startTime: this.ruleForm.time,
        endTime: this.ruleForm.time1,
        targetName: this.ruleForm.name,
        targetPhone: this.ruleForm.phone,
        jobNo: this.ruleForm.jobNo,
        targetType: this.ruleForm.type,
      };
      this.$axios
        .post(`/admapi/platformwallet/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
      this.$axios
        .post(`/admapi/platformwallet/statistic`, param)
        .then(({ data }) => {
          this.pageInfo = data;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
